<template>
    <div>
        <modal
        class="new-modal-default-light"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="1250"
        :height="705"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">Select Call Reports</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex pl-3">
                                <i class="icon icon-magnify d-flex align-items-center justify-content-center" style="border: 1px solid rgba(32, 106, 211, 0.56); border-right: 0; border-radius: 15px 0px 0px 15px; height: 32px"></i>
                                <input type="text" class="pl-2" v-model="search_key" placeholder="Search by Author, Call Report ID, Call Report Type" style="border: 1px solid rgba(32, 106, 211, 0.56); border-left: 0; border-radius: 0px 15px 15px 0px; width: 40em">
                            </div>
                            <div class="d-flex">
                                <button class="btn btn-des-small mr-4" style="color: #fff; background: #00448b;" @click="filters = true">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px">
                                    Filter
                                </button>
                                <button class="btn btn-des-small mr-4" style="color: #fff; background: rgba(0, 0, 0, 0.27);" :style="callReportsSelected.length ? 'background: #008a63 !important' : ''" @click="add">+ Add Call Reports</button>
                            </div>
                        </div>
                        <div class="table-block mt-4">
                            <table class="team-list-table w-100">
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                <input type="checkbox" class="custom-control-input" v-model="allSelected" @change="addRemoveAllCallReport" />
                                                <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                                <span class="form-check-description fw-600"></span>
                                            </label>
                                        </th>
                                        <th>
                                            CALL REPORT ID
                                        </th>
                                        <th>
                                            COMPANY NAME
                                        </th>
                                        <th>
                                            CUSTOMER
                                        </th>
                                        <th>
                                            CALL REPORT TYPE
                                        </th>
                                        <th>
                                            STATUS
                                        </th>
                                        <th>
                                            TITLE NAME
                                        </th>
                                        <th>
                                            START DATE
                                        </th>
                                        <th>
                                            AUTHOR
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="w-100" v-if="ajaxCallinprogress && !callReportList.length">
                                        <td colspan="9">
                                            <div class="d-flex align-items-center justify-content-center w-100">
                                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="callReportList.length == 0">
                                        <td colspan="9">
                                            <div class="d-flex justify-content-center fw-500">
                                                No Call Report Found
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="callReport in callReportList" :key="callReport._id">
                                        <td>
                                            <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                                <input type="checkbox" class="custom-control-input" :checked="callReportsSelected.find(x => x.call_report_number === callReport.call_report_number)" @change="addRemoveCallReport(callReport)" />
                                                <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                                <span class="form-check-description fw-600"></span>
                                            </label>
                                        </td>
                                        <td>
                                            {{ callReport.hasOwnProperty('call_report_number') ? callReport.call_report_number : "-" }}
                                        </td>
                                        <td>
                                            <span style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block;">
                                                {{ loggedInUser.company_details.company_name }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ callReport.external_attendees && callReport.external_attendees.length ? callReport.external_attendees[0].company_name || "-" : "-" }}
                                        </td>
                                        <td>
                                            {{ callReport.call_report_type }}
                                        </td>
                                        <td>
                                            Completed
                                        </td>
                                        <td>
                                            <span style="max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block;">
                                                {{ callReport.title }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ callReport.meeting_time_from != "-" ? moment(callReport.meeting_time_from).format("DD/MM/YYYY") : "-" }}
                                        </td>
                                        <td>
                                            {{ callReport.author_name }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                            <input class="text-center" type="text" v-model.number="limit" @input="getCallReportList" onkeypress="return event.charCode >= 48 && event.charCode <= 57" style="min-height: 30px; width: 46px; border: solid 2px rgba(103, 103, 103, 0.84); border-radius: 5px; padding-right: 22px;" />
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg" style="margin-left: -20px;">
                            <span class="page-info pr-2 pl-6 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                    <i class="icon-chevron-double-left"></i>
                                </el-tooltip>
                            </button>
                            <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                    <i class="icon icon-chevron-left"></i>
                                </el-tooltip>
                            </button>
                            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                            <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                    <i class="icon icon-chevron-right"></i>
                                </el-tooltip>
                            </button>
                            <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                    <i class="icon-chevron-double-right"></i>
                                </el-tooltip>
                            </button>
                        </div>
                    </div>
                    <div class="filters-div" v-if="filters">
                        <div class="d-flex justify-content-between align-items-center px-2" style="background: #0000cd; border-radius: 7.5px 7.5px 0px 0px;">
                            <span style="font-weight: 600; color: #fff;">
                                Filters(<span style="color: #ffba00;">{{ author_names_selected.length + company_names_selected.length + call_report_category_selected.length + meeting_type_selected.length + customers_selected.length + departments_selected.length + location_selected.length + title_name_selected.length + dateRange.length ? 1 : 0 }}</span>)
                            </span>
                            <span class="d-flex align-items-center">
                                <div class="pointer" @click="getCallReportList()">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/tick.svg" height="42px" />
                                </div>
                                <div class="pointer" @click="resetFilters()">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/newicon/blue-reset-icon.svg" />
                                </div>
                                <div @click="closeFilters()" class="pointer">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/icons/newicon/blue-cross-icon.svg" />
                                </div>
                            </span>
                        </div>
                        <div class="p-2" style="background: #FFF; box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%); border-radius: 0px 0px 7.5px 7.5px;">
                            <div class="row mx-2">
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Author</h6>
                                    <multiselect
                                    :max-height="150"
                                    class="digi-multiselect filter-multiple"
                                    :searchable="true"
                                    placeholder="Type to Search"
                                    :options="author_name_options"
                                    v-model="author_names_selected"
                                    :loading="isLoading.author"
                                    :multiple="true"
                                    :taggable="false"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :clear-on-select="false"
                                    open-direction="bottom"
                                    @open="fetchAuthor"
                                    @search-change="fetchAuthor"
                                    @remove="removeAuthor"
                                    >
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeAuthor(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Authors Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Company Name</h6>
                                    <multiselect class="digi-multiselect filter-multiple" name="companyname" :searchable="true" :multiple="true" v-model="company_names_selected" :options="company_name_options" @remove="removeCompName" placeholder="Type to Search">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeCompName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Company Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Call Report Type</h6>
                                    <multiselect class="digi-multiselect filter-multiple" name="reporttype" :searchable="true" :multiple="true" v-model="call_report_category_selected" :options="call_report_category_options" @remove="removeCallReportType" placeholder="Type to Search">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeCallReportType(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Call Report Types Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Meeting Type</h6>
                                    <multiselect class="digi-multiselect filter-multiple" name="meetingtype" :searchable="true" :multiple="true" v-model="meeting_type_selected" :options="['Chat', 'Email', 'In Person', 'Audio Call', 'Video Call']" @remove="removeMeetingType" placeholder="Type to Search">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeMeetingType(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Meeting Types Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Customer</h6>
                                    <multiselect
                                    :max-height="150"
                                    class="digi-multiselect filter-multiple"
                                    :searchable="true"
                                    placeholder="Type to Search"
                                    :options="customer_options"
                                    v-model="customers_selected"
                                    :loading="isLoading.customer"
                                    :multiple="true"
                                    :taggable="false"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :clear-on-select="false"
                                    open-direction="bottom"
                                    @open="fetchCustomers"
                                    @search-change="fetchCustomers"
                                    @select="updateBranch"
                                    label="company_name"
                                    track-by="_id"
                                    @remove="removeCustomer"
                                    >
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option.company_name }}</span>
                                                <span class="custom__remove pointer" @click="removeCustomer(option.company_name)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Customers Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Department</h6>
                                    <multiselect class="digi-multiselect filter-multiple" name="department" :searchable="true" :multiple="true" v-model="departments_selected" :options="department_options" @remove="removeDepartment" placeholder="Type to Search">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeDepartment(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Departments Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Location</h6>
                                    <multiselect class="digi-multiselect filter-multiple" name="location" :searchable="true" :multiple="true" v-model="location_selected" :options="countries" @remove="removeLocation" placeholder="Type to Search">
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeLocation(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Location Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Start Date</h6>
                                    <date-picker class="date-width callreport-listdate" format="DD/MM/YYYY" type="date" lang="en" :clearable="false" :editable="false" v-model="dateRange" confirm confirm-text="APPLY"></date-picker>
                                </div>
                                <div class="col-6 mt-4">
                                    <h6 class="fs-14 text-secondary">Title Name</h6>
                                    <multiselect
                                    :max-height="150"
                                    class="digi-multiselect filter-multiple"
                                    :searchable="true"
                                    placeholder="Type to Search"
                                    :options="title_name_options"
                                    v-model="title_name_selected"
                                    :loading="isLoading.title"
                                    :multiple="true"
                                    :taggable="false"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :clear-on-select="false"
                                    open-direction="top"
                                    @open="fetchTitleName"
                                    @search-change="fetchTitleName"
                                    @remove="removeTitleName"
                                    >
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag">
                                            <span class="filterSelectedName">{{ option }}</span>
                                                <span class="custom__remove pointer" @click="removeTitleName(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Title Names Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import moment from "moment";
import countries from "./json/countries.json";
import { HalfCircleSpinner } from "epic-spinners";
export default {
    data() {
        return {
            ajaxCallinprogress: false,
            start: 0,
            end: 0,
            total: 0,
            count: 0,
            limit: 10,
            skip:0,
            temp_total:0,
            skip_temp: 0,
            search_key: "",
            callReportList: [],
            callReportsSelected: [],
            allSelected: false,
            filters: false,
            isLoading: {
                // authorname: false,
                customer: false,
                // titlename: false,
                author:false,
                title:false
            },
            call_report_category_options: [],
            call_report_category_selected: [],
            author_name_options: [],
            author_names_selected: [],
            company_name_options: [],
            company_names_selected: [],
            customer_options: [],
            customers_selected: [],
            branch_options: [],
            branches_selected: [],
            department_options: [],
            departments_selected: [],
            title_name_options: [],
            title_name_selected: [],
            meeting_type_selected: [],
            location_selected: [],
            dateRange: [],
            countries: countries,
        }
    },
    props: ["modal_name","lead_call_reports"],
    components:{
        HalfCircleSpinner
    },
    methods: {
        removeAuthor(option){
            this.filterCallReport = true;
            this.author_names_selected.forEach((el,index)=>{
                if(el == option){
                    this.author_names_selected.splice(index,1)
                }
            })
        },
        removeCompName(option) {
            this.filterCallReport = true;
            this.company_names_selected.forEach((el,index)=>{
                if(el == option){
                    this.company_names_selected.splice(index,1)
                }
            })
        },
        removeCallReportType(option) {
            this.filterCallReport = true;
            this.call_report_category_selected.forEach((el,index)=>{
                if(el == option){
                    this.call_report_category_selected.splice(index,1)
                }
            })
        },
        removeMeetingType(option) {
            this.filterCallReport = true;
            this.meeting_type_selected.forEach((el,index)=>{
                if(el == option){
                    this.meeting_type_selected.splice(index,1)
                }
            })
        },
        removeCustomer(option) {
            this.filterCallReport = true;
            this.customers_selected.forEach((el,index)=>{
                if(el.company_name == option){
                    this.customers_selected.splice(index,1)
                }
            })
        },
        removeTitleName(option) {
            this.filterCallReport = true;
            this.title_name_selected.forEach((el,index)=>{
                if(el == option){
                    this.title_name_selected.splice(index,1)
                }
            })
        },
        removeBranch(option) {
            this.filterCallReport = true;
            this.branches_selected.forEach((el,index)=>{
                if(el == option){
                    this.branches_selected.splice(index,1)
                }
            })
        },
        removeDepartment(option) {
            this.filterCallReport = true;
            this.departments_selected.forEach((el,index)=>{
                if(el == option){
                    this.departments_selected.splice(index,1)
                }
            })
        },
        removeLocation(option) {
            this.filterCallReport = true;
            this.location_selected.forEach((el,index)=>{
                if(el == option){
                    this.location_selected.splice(index,1)
                }
            })
        },
        moment(date) {
            return moment(date);
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getCallReportList();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getCallReportList();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.getCallReportList();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.skip_temp =  this.total - this.limit
            this.skip = this.skip_temp
            this.getCallReportList();
        },
        resetFilters(){
            this.author_names_selected = [],
            this.company_names_selected = [],
            this.customers_selected = [],
            this.branches_selected = [],
            this.departments_selected = [],
            this.title_name_selected = [],
            this.dateRange = [],
            this.location_selected =[],
            this.call_report_category_selected=[],
            this.meeting_type_selected =[]
        },
        closeFilters() {
            this.resetFilters();
            this.filters = !this.filters;
            this.getCallReportList()
        },
        hideSelf() {
            // this.ajaxCallinprogress = false;
            // this.start = 0;
            // this.end = 0;
            // this.total = 0;
            // this.count = 0;
            // this.limit = 10;
            this.search_key = "";
            this.callReportList = [];
            // this.callReportsSelected = [];
            this.getCallReportList();
            this.$modal.hide(this.modal_name);
        },
        addRemoveAllCallReport() {
            if (this.allSelected) {
                this.callReportsSelected = [];
                this.callReportList.forEach(x => {
                    this.callReportsSelected.push({
                        _id: x._id,
                        call_report_number: x.call_report_number,
                        title: x.title,
                    });
                });
            } else {
                this.callReportsSelected = [];
            }
        },
        addRemoveCallReport(callReport) {
            if (this.callReportsSelected.find(x => x.call_report_number === callReport.call_report_number)) {
                this.allSelected = false;
                this.callReportsSelected = this.callReportsSelected.filter(x => {
                    if (x.call_report_number != callReport.call_report_number) {
                        return x;
                    }
                });
            } else {
                this.callReportsSelected.push({ _id: callReport._id, call_report_number: callReport.call_report_number, title: callReport.title });
                if(this.callReportsSelected.length == this.callReportList.length) {
                    this.allSelected = true;
                }
            }
        },
        add() {
            if (this.callReportsSelected.length) {
                this.callReportsSelected.forEach(x => {
                    if (!this.lead_call_reports.find(i => i.call_report_number === x.call_report_number)) {
                        this.lead_call_reports.push({ _id: x._id, call_report_number: x.call_report_number, title: x.title });
                    }
                });
            }
            this.hideSelf();
        },
        dropdownClosed() {
            this.search_key = "";
            this.count = 0;
        },
        async fetchAuthor(key) {
            this.isLoading.author = true;
            this.author_name_options = [];
            let searchKey = "";
            if (key) {
                searchKey = key;
            }
            let params = {
                search_key: searchKey,
                skip: 0,
                limit: 10,
                active_status: "active",
                company_id: this.account.company_id,
            };
            let res = await this.$http.post("/employees/get_employees", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                this.author_name_options.push(x.full_name);
                });
                this.isLoading.author = false;
            }
        },
        // async getAuthors(key) {
        //     this.isLoading.authorname = true;
        //     this.author_name_options = [];
        //     if (key) {
        //         this.search_key = key;
        //     }
        //     let params = {
        //         skip: this.count * this.limit,
        //         limit: this.limit,
        //         search_key: this.search_key,
        //         active_status: "active",
        //         company_id: this.account.company_id,
        //     };
        //     let res = await this.$http.post("/employees/get_employees", params);
        //     if (res.data.status_id == 1) {
        //         res.data.response.forEach(x => {
        //             this.author_name_options.push(x.full_name);
        //         });
        //         this.isLoading.authorname = false;
        //     }
        // },
        // async getMoreAuthors(reached) {
        //     if (reached) {
        //         this.isLoading.authorname = true;
        //         this.count += 1;
        //         let params = {
        //             skip: this.count * this.limit,
        //             limit: this.limit,
        //             search_key: this.search_key,
        //             active_status: "active",
        //             company_id: this.account.company_id,
        //         };
        //         let res = await this.$http.post("/employees/get_employees", params);
        //         if (res.data.status_id == 1) {
        //             res.data.response.forEach(x => {
        //                 this.author_name_options.push(x.full_name);
        //             });
        //             this.isLoading.authorname = false;
        //         }
        //     }
        // },
        async getCallReportType() {
            let res = await this.$http.get("/call_report/get_call_report_category");
            if (res.data.status_id == 1) {
                res.data.response.value.forEach(x => {
                    this.call_report_category_options.push(x.name);
                });
            }
        },
        async fetchCustomers(key) {
            this.isLoading.customer = true;
            this.customer_options = [];
            let searchKey = "";
            if (key) {
                searchKey = key;
            }
            let params = {
                skip: 0,
                limit: 10,
                search_key: searchKey,
            };
            let res = await this.$http.post("/shadow_companies/get_companies", params);
            if (res.data.status_id == 1) {
                this.customer_options = [];
                res.data.response.forEach(x => {
                this.customer_options.push(x);
                });
                this.isLoading.customer = false;
            }
        },
        // async getCustomers(key) {
        //     this.isLoading.customer = true;
        //     this.customer_options = [];
        //     if (key) {
        //         this.search_key = key;
        //     }
        //     let params = {
        //         skip: this.count * this.limit,
        //         limit: this.limit,
        //         search_key: this.search_key,
        //     };
        //     let res = await this.$http.post("/shadow_companies/get_companies", params);
        //     if (res.data.status_id == 1) {
        //         res.data.response.forEach(x => {
        //             this.customer_options.push(x);
        //         });
        //         this.isLoading.customer = false;
        //     }
        // },
        // async getMoreCustomers(reached) {
        //     if (reached) {
        //         this.isLoading.customer = true;
        //         this.count += 1;
        //         let params = {
        //             skip: this.count * this.limit,
        //             limit: this.limit,
        //             search_key: this.search_key,
        //         };
        //         let res = await this.$http.post("/shadow_companies/get_companies", params);
        //         if (res.data.status_id == 1) {
        //             res.data.response.forEach(x => {
        //                 this.customer_options.push(x);
        //             });
        //             this.isLoading.customer = false;
        //         }
        //     }
        // },
        async updateBranch(selectedOption) {
            this.branch_options = [];
            let params = {
                company_name: [...new Set(this.customers_selected.map(x => x.company_name)), selectedOption.company_name],
                call_report: true,
            };
            let res = await this.$http.post("/shadow_companies/get_branch", params);
            if (res.data.status_id == 1) {
                res.data.response.forEach(x => {
                    this.branch_options.push(x);
                    x.departments.forEach(i => {
                        this.department_options.push(i);
                    });
                });
            }
        },
        async fetchTitleName(key) {
            this.isLoading.title = true;
            this.title_name_options = [];
            let searchKey = "";
            if (key) {
                searchKey = key;
            }
            let params = {
                search_key: searchKey,
                skip: 0,
                limit: 10,
            };
            let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
            if (res.data.status_id == 1) {
                this.title_name_options = res.data.response;
                this.isLoading.title = false;
            }
        },
        // async getTitleNames(key) {
        //     this.isLoading.titlename = true;
        //     if (key) {
        //         this.search_key = key;
        //     }
        //     let params = {
        //         skip: this.count * this.limit,
        //         limit: this.limit,
        //         search_key: this.search_key,
        //     };
        //     let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
        //     if (res.data.status_id == 1) {
        //         this.title_name_options = res.data.response;
        //         this.isLoading.titlename = false;
        //     }
        // },
        // async getMoreTitleNames(reached) {
        //     if (reached) {
        //         this.isLoading.titlename = true;
        //         this.count += 1;
        //         let params = {
        //             skip: this.count * this.limit,
        //             limit: this.limit,
        //             search_key: this.search_key,
        //         };
        //         let res = await this.$http.post("/call_report/get_title_names_dropdown", params);
        //         if (res.data.status_id == 1) {
        //             this.title_name_options = res.data.response;
        //             res.data.response.forEach(x => {
        //                 this.title_name_options.push(x);
        //             });
        //             this.isLoading.titlename = false;
        //         }
        //     }
        // },
        async getCallReportList() {
            this.ajaxCallinprogress = true;
            if (this.filters) {
                this.filters = !this.filters;
            }
            let params = {
                search_key: this.search_key,
                limit: this.limit == "" || this.limit == 0 || this.limit < 0 ? 1 : this.limit,
                skip: this.skip > 0 ? this.skip : this.count * this.limit,
                filter_json: {},
                from_leads: true,
            };
            if (this.author_names_selected.length) {
                Object.assign(params.filter_json, {
                    author_name: this.author_names_selected,
                });
            }
            if (this.company_names_selected.length) {
                Object.assign(params.filter_json, {
                    company_name: this.company_names_selected,
                });
            }
            if (this.call_report_category_selected.length) {
                Object.assign(params.filter_json, {
                    call_report_category: this.call_report_category_selected,
                });
            }
            if (this.meeting_type_selected.length) {
                Object.assign(params.filter_json, {
                    meeting_type: this.meeting_type_selected,
                });
            }
            if (this.customers_selected.length) {
                Object.assign(params.filter_json, {
                    customer: [...new Set(this.customers_selected.map(x => x._id))],
                });
            }
            if (this.departments_selected.length) {
                Object.assign(params.filter_json, {
                    department: this.departments_selected,
                });
            }
            if (this.location_selected.length) {
                Object.assign(params.filter_json, {
                    location: this.location_selected,
                });
            }
            if (this.dateRange.length) {
                Object.assign(params.filter_json, {
                    created_date: {
                        start_date: ("0" + new Date(this.dateRange[0]).getDate()).slice(-2) +  "/" + ("0" + (new Date(this.dateRange[0]).getMonth()+1)).slice(-2) + "/" + new Date(this.dateRange[0]).getFullYear(),
                        end_date: ("0" + new Date(this.dateRange[1]).getDate()).slice(-2) + "/" + ("0" + (new Date(this.dateRange[1]).getMonth()+1)).slice(-2) + "/" + new Date(this.dateRange[1]).getFullYear(),
                    },
                });
            }
            if (this.title_name_selected.length) {
                Object.assign(params.filter_json, {
                    title_name: this.title_name_selected,
                });
            }
            let res = await this.$http.post("/call_report/list_view", params);
            if (res.data.status_id == 1) {
                this.callReportList = res.data.response;
                this.total = res.data.total;
                this.start = this.count * this.limit + 1;
                this.end = this.count * this.limit + this.limit < this.total ? this.count * this.limit + this.limit : this.total;
                this.ajaxCallinprogress = false;
            }
        }
    },
    mounted(){
        // this.getCallReportList();

    },
    created() {
        this.getCallReportList();
        this.company_name_options.push(this.account.company_name);
        this.getCallReportType();
    },
    watch: {
        search_key: function() {
            this.getCallReportList();
        },
        count: function() {
            this.getCallReportList();
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        account() {
            return this.$store.getters.selectedCompany;
        },
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        }
    }
}
</script>

<style scoped>
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px;
        font-size: 14px;
        font-weight: 600;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 10px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
    }
    .forwardBackward {
        border-radius: 5px;
        background: #f4f4fb;
        padding: 4px;
    }
    .filters-div {
        position: absolute;
        top: 8.8em;
        right: 1.2em;
        width: 50%;
        z-index: 9999;
        border-radius: 7.5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CreateLeadsAddCallReportModal.vue